import { createSelector } from 'reselect'

import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import activityOriginSelector from 'redux/selectors/activity_creation/activity_origin_selector'
import presentationOriginTypes from 'helpers/enums/presentationOriginTypes'

const getUserExtraData = state => state.user.extra

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.ACTIVITY_BANKS,
])

const hasActivityBanksAccessSelector = createSelector(
	[ featureFlagsSelector, getUserExtraData, activityOriginSelector ],
	(featureFlags, userExtra, activityOrigin) => !!(
		featureFlags[featureFlagsTypes.ACTIVITY_BANKS]
		&& userExtra
		&& userExtra.hasActivityBanksAccess
		&& activityOrigin === presentationOriginTypes.REGULAR
	)
)

export default hasActivityBanksAccessSelector
